import React from 'react';
import { WidgetProps } from '@rjsf/core';
import { Form, InputOnChangeData, Label } from 'semantic-ui-react';
import { formatPercentage } from '../../common/formatPercentage';

interface PercentWidgetState {
  displayValue?: string;
}
export default class PercentWidget extends React.Component<WidgetProps, PercentWidgetState> {
  state: PercentWidgetState = {};
  isOnChange: boolean = false;

  validateAndFormatInput(inputValue: string, prevDisplayValue: string): string {
    // Remove invalid characters
    let cleaned = inputValue.trim().replace(/[^\d.]|^\s*\s*$/g, '');

    // Prevent multiple decimal points - strip all dots after the first one
    const firstDotIndex = cleaned.indexOf('.');
    if (firstDotIndex !== -1) {
      cleaned = cleaned.substring(0, firstDotIndex + 1) + cleaned.substring(firstDotIndex + 1).replace(/\./g, '');
    }

    // Detect if user is adding characters vs replacing
    const prevLength = prevDisplayValue?.length || 0;
    const newLength = cleaned.length;
    const isAdding = newLength > prevLength;
    
    // Allow exactly "100"
    if (cleaned === '100') {
      return '100';
    }

    const decimalIndex = cleaned.indexOf('.');

    if (decimalIndex === -1) {
      // No decimal - limit to 2 digits (0-99), only "100" is allowed as 3 digits
      if (isAdding && cleaned.length > 2) {
        return prevDisplayValue;
      }
    } else {
      // Has decimal
      const beforeDecimal = cleaned.substring(0, decimalIndex);
      const afterDecimal = cleaned.substring(decimalIndex + 1);

      // Don't allow decimals after "100"
      if (beforeDecimal === '100') {
        return '100';
      }

      if (beforeDecimal.length > 2) {
        return prevDisplayValue;
      }

      if (afterDecimal.length > 2) {
        return beforeDecimal + '.' + afterDecimal.substring(0, 2);
      }
    }
    
    return cleaned;
  }

  onChange(e: React.ChangeEvent<EventTarget>, data: InputOnChangeData): void {
    this.isOnChange = true;
    
    // Validate and format input based on rules
    let inputValue = this.validateAndFormatInput(data.value, this.state.displayValue || '');
    
    console.log(inputValue, data, "on Change");
    
    // Prevent multiple leading zeros (but allow "0.")
    if (inputValue.startsWith('0') && inputValue.length > 1 && inputValue[1] !== '.') {
      inputValue = inputValue.replace(/^0+/, '0');
    }
    
    // If the input is being cleared or is empty, handle it
    if (inputValue === '') {
      this.props.onChange(undefined);
      this.setState({ displayValue: '' });
      console.log(undefined, '', '', "there is value");
      return;
    }
    
    let value = Math.round(Number(inputValue) * 100) / 10000;
    let displayValue = String(inputValue);
    
    // If the value is greater than 100%, change it to 100%
    if (value !== undefined && value > 1) {
      value = 1;
      displayValue = '100';
    }
    
    console.log(value, displayValue, inputValue, "there is value");
    // Call onChange if the value is actually different
    const currentDisplayValue = this.props.value ? (this.props.value * 100).toFixed(2).replace(/\.?0+$/, '') : '';
    if (currentDisplayValue !== inputValue) {
      this.props.onChange(value);
    }
    
    // Always preserve the display value to maintain trailing zeros and decimal points
    this.setState({ displayValue });
  }

  formatPercentage(value: number): string {
    return formatPercentage(value);
  }

  render(): React.ReactNode {
    console.log(this.props.value, this.state.displayValue ,"First of all");
    
    let value: number|string|undefined = isNaN(this.props.value * 100) ? undefined : this.formatPercentage(this.props.value);
    
    console.log(value ,"after");
    this.state.displayValue = this.isOnChange ? this.state.displayValue : value; 
    const displayValue = this.state.displayValue !== undefined ? this.state.displayValue : typeof value !== 'undefined' ? String(value) : '';
    console.log(displayValue, this.state.displayValue, String(value),this.props.value,"Under Render");
    this.isOnChange = false;
    
    // If it's a read-only field, output the value post-fixed with a % sign
    if (this.props.schema.readOnly) {
      value = isNaN(Number(value) / 100) ? undefined : Number(value) / 100;
      return (
        <Form.Field>
          <label>{this.props.schema.title ? this.props.schema.title : this.props.id.replace(/^root_/, '')}</label>
          <span>{value ? this.formatPercentage(value) : ''}</span>
        </Form.Field>
      );
    }

    return (
      <Form.Input
        type="string"
        label={this.props.schema.title}
        icon="percent"
        value={displayValue}
        error={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void =>
          this.onChange(e, data)
        }
        style={{ width: this.props.uiSchema['ui:options']?.fullWidth ? '100%' : '110px' }}
        onBlur={(): void => this.props.onBlur(this.props.id, displayValue)}
        onFocus={(): void => this.props.onFocus(this.props.id, displayValue)}
        required={this.props.required}
        placeholder={this.props.uiSchema['ui:options']?.placeholder}
      />
    );
  }
}